import { AI_MATE_EXPERIENCE_ID, FEEDBACK_COLLECTOR_ENTRYPOINT_ID } from '../../constants/private';
import { serviceProductToProductKey } from './serviceProductToProductKey';
import type { GlobalConfig, CreateGlobalConfigArgs } from './types';

export const createGlobalConfig = ({
	profileData,
	displaySubmitFlag,
	siteId,
	activationId,
	enableExplicitAgentSessionSubscriptionSharding,
	product,
	experienceId = AI_MATE_EXPERIENCE_ID,
	workspaceId,
	orgId,
	assistanceServiceConfig,
	closeChat,
	emojiProvider,
	preventAbortRequestsOnStagingModalClose,
	preventAbortRequestsOnStandaloneChatClose,
	renderingTouchpoint,
	inProductExperience,
	smartCreationContext,
	jiraIssueCommentEditor,
	autocompletePageContentSource,
	editorContentIdResolver,
	contextualPromptAnalyticsMetadata,
	moduleAnalyticsContext,
	analyticsProductHeader,
	loadLocalModelAutocomplete,
	useCurrentBrowsingContext,
	requestedSkills,
	creationContextOverrides,
}: CreateGlobalConfigArgs): GlobalConfig => ({
	profileData,
	feedbackCollector: {
		entryPointId: FEEDBACK_COLLECTOR_ENTRYPOINT_ID,
		displaySubmitFlag,
	},
	siteId,
	activationId,
	enableExplicitAgentSessionSubscriptionSharding,
	experienceId,
	workspaceId,
	productKey: serviceProductToProductKey(product),
	productHeader: analyticsProductHeader ?? product,
	orgId,
	assistanceServiceConfig,
	closeChat,
	emojiProvider,
	preventAbortRequestsOnStagingModalClose,
	preventAbortRequestsOnStandaloneChatClose,
	renderingTouchpoint,
	inProductExperience,
	smartCreationContext,
	jiraIssueCommentEditor,
	autocompletePageContentSource,
	editorContentIdResolver,
	contextualPromptAnalyticsMetadata,
	moduleAnalyticsContext,
	analyticsProductHeader,
	loadLocalModelAutocomplete,
	useCurrentBrowsingContext,
	requestedSkills,
	creationContextOverrides,
});
